import { api } from '@/utils/api'
import alert from '../helpers/alert'

const state = () => {
  return {
    btnSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnCancel: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDraft: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnItemSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnReject: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDelete: {
      disabled: false,
      loading: false,
      hide: true
    },
    tableTab: {
      label: null,
      value: null,
      url: null,
      currentUrl: null,
      page: 1
    },
    search: {
      field: null,
      type: 'like',
      value: null,
      companySelected: [],
      statusSelected: []
    },
    filterOption: [],
    docStatusOption: [],
    isClaim: false,
    isApprove: false,
    countMyDoc: 0,
    files: [],
    memo: [],
    documentPath: null,
    documentPathText: null,
    payForOption: []
  }
}

const getters = {
  getPayForDefault(state) {
    // console.log('getter: ', state.payForOption[0].label)
    return state.payForOption.length ? state.payForOption[0].value : null
  },
  getPayForTextSelected(state) {
    return payFor => {
      // console.log('getters: ', payFor)
      return state.payForOption.find(item => item.value == payFor)
    }
  },
  getFileAttach(state) {
    return state.files.map(item => {
      return {
        id: item.id,
        path_file: item.path_file,
        path_thumbnail: item.path_thumbnail,
        url_file: item.url_file,
        url_thumbnail: item.url_thumbnail
      }
    })
  }
}

const mutations = {
  initBtn(state) {
    state.btnSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnCancel = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDraft = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnItemSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnReject = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDelete = {
      disabled: false,
      loading: false,
      hide: true
    }
    // state.docStatusOption = []
    state.isClaim = false
    state.isApprove = false
    state.countMyDoc = 0
    state.files = []
    state.documentPath = null
    state.documentPathText = null
  },
  setBtnActive(state, data) {
    state[data.type].loading = !state[data.type].loading
    state[data.type].disabled = !state[data.type].disabled
  },
  setBtnActiveFix(state, data) {
    state[data.type].loading = data.status
    state[data.type].disabled = data.status
  },
  setBtn(state, data) {
    state[data.type][data.value] = !state[data.type][data.value]
  },
  setFile(state, data) {
    state.files.push(data)
  },
  removeFile(state, id) {
    const newFile = state.files.filter(item => {
      return item.id !== id
    })
    state.files = newFile
  },
  setDocumentPath(state, data) {
    state.documentPath = data
  },
  setDocumentPathText(state, data) {
    state.documentPathText = data
  },
  setMemo(state, data) {
    state.memo = data
  },
  setPayFor(state, data) {
    state.payForOption = data
  },
  setDocStatusOption(state, data) {
    state.docStatusOption = data
  },
  setFilterOption(state, data) {
    state.filterOption = data
  },
  setTableTab(state, tab) {
    state.tableTab.label = tab.label
    state.tableTab.value = tab.value
    state.tableTab.url = tab.url
    state.tableTab.currentUrl = tab.url
  },
  setCompanyAndStatus(state, data) {
    state.search.companySelected = data.companySelected
    state.search.statusSelected = data.statusSelected
    state.search.field = data.field
    state.search.value = data.value
  },
  updateTableTab(state, tab) {
    state.tableTab.currentUrl = tab.currentUrl
    state.tableTab.page = tab.page
  },
  clearTableTab(state, data) {
    state.search.companySelected = []
    state.search.statusSelected = []
    state.search.field = data.field
    state.search.value = null

    state.tableTab.currentUrl = state.tableTab.url
    state.tableTab.page = 1
  },
  clearSelectedCompanyAndStatus(state) {
    state.search.companySelected = []
    state.search.statusSelected = []
  },
  setIsClaim(state, data) {
    state.isClaim = data
  },
  setIsApprove(state, data) {
    state.isApprove = data
  },
  setApproveOption(state, data) {
    state.approveOption = data
  },
  setCountMyDoc(state, count) {
    state.countMyDoc = count
  }
}

const actions = {
  async loadDocumentPath({ commit }, payload) {
    // console.log('load document path', payload)
    if (payload.specialPath === null) {
      await api
        .get(
          `/hr/employee/documentPath?doc_type=CA&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
        )
        .then(res => {
          if (res.code == 200) {
            commit('setDocumentPath', res.data.documentPath)
            commit('setDocumentPathText', res.data.documentPathText)
          }
        })
    } else {
      await api
        .get(
          `/hr/employee/documentPath?doc_type=CA&special_path=${payload.specialPath}&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
        )
        .then(res => {
          if (res.code == 200) {
            commit('setDocumentPath', res.data.documentPath)
            commit('setDocumentPathText', res.data.documentPathText)
          }
        })
    }
  },
  async loadMemo({ commit }, data) {
    await api
      .get(`/memo/memo/getMyDocForUse?group_month=true&back_month=${process.env.VUE_APP_API_MEMO_BACK_MONTH}`)
      .then(res => {
        if (res.code == 200) {
          commit('setMemo', res.data)
        }
      })
  },
  async loadPayFor({ commit, state }) {
    if (state.payForOption.length === 0) {
      await api.get('/reimbursement/ca/getOptionPayFor').then(res => {
        if (res.code == 200) {
          commit('setPayFor', res.data)
        }
      })
    }
  },
  async loadDocStatusOption({ commit, state, rootState }) {
    if (state.docStatusOption.length == 0) {
      await api
        .get(
          `/reimbursement/ca/getOptionDocMenu?showTabMonitor=${rootState.auth.info.showTabMonitor}&roleCode=${rootState.auth.info.roleCode}`
        )
        .then(res => {
          if (res.code == 200) {
            commit('setDocStatusOption', res.data)
            commit('setTableTab', res.data[0])
          }
        })
    }
  },
  async loadFilterOption({ commit, state }) {
    if (state.filterOption.length == 0) {
      await api.get('/reimbursement/ca/allOption').then(res => {
        commit('setFilterOption', res.data)
      })
    }
  },
  async approveClaim({ commit }, data) {
    return await api
      .post('/reimbursement/ca/claim', data)
      .then(res => {
        if (res.code == 200) {
          commit('setIsClaim', false)
          alert.success()
          return res.data.employee_id
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        alert.error(e.message)
        return false
      })
  },
  async approveCA({ commit }, data) {
    return await api
      .post('/reimbursement/ca/approve', data)
      .then(res => {
        if (res.code == 200) {
          commit('setIsApprove', true)
          alert.success()
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        alert.error(e.message)
        return false
      })
  },
  async loadApproveOption({ commit, state }, data) {
    await api
      .get(
        `/reimbursement/ca/getOptionApproveResult?employeeId=${data.employeeID}&docId=${data.docID}`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setApproveOption', res.data)
        }
      })
  },

  setTableTab({ commit }, tab) {
    commit('setTableTab', tab)
  },
  async loadCountMyDoc({ commit }, employeeId) {
    await api
      .get(`/reimbursement/ca/countDocWait/${employeeId}`)
      .then(async res => {
        if (res.code == 200) {
          commit('setCountMyDoc', res.data.doc_wait)
          commit(
            'global/setDocWaitType',
            { type: 'ca', value: res.data.doc_wait },
            { root: true }
          )
        }
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
